import { getTeam } from "@/api/management";
import InviteUser from "@/components/inviteUser/InviteUser";
import Table from "@/components/Table/Table";
import TableHeader from "@/components/TableHeader/TableHeader";
import { useQuery } from "@tanstack/react-query";
function ManageTeam() {
  const { data, isLoading } = useQuery({
    queryKey: ["team"],
    queryFn: getTeam,
  });

  return (
    <div>
      <TableHeader left={<InviteUser />} />
      <Table
        data={data}
        loading={isLoading}
        columns={[
          { key: "name", label: "Name" },
          { key: "email", label: "E-mail" },
        ]}
        rowKey={"email"}
      />
    </div>
  );
}

export default ManageTeam;
